import { render, staticRenderFns } from "./SocietyMatchWizardsStepFive.vue?vue&type=template&id=6ce6b0c5&scoped=true"
import script from "./SocietyMatchWizardsStepFive.vue?vue&type=script&lang=js"
export * from "./SocietyMatchWizardsStepFive.vue?vue&type=script&lang=js"
import style0 from "./SocietyMatchWizardsStepFive.vue?vue&type=style&index=0&id=6ce6b0c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce6b0c5",
  null
  
)

export default component.exports